module.exports = __webpack_public_path__ + "img/01.54177be9.jpg";